import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {
    MaterialReactTable,
    MRT_BottomToolbar,
    MRT_GlobalFilterTextField, MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Button, TableRow, Tooltip} from "@mui/material";
import FilterUtil from "../../../../../utils/common/FilterUtil";
import CellCheckboxWithUnable from "../../../сheckbox/CellCheckboxWithUnable";
import DetailService, {
    applyDetailOrderUpdateToRow,
    detailOrderIdsEqual,
} from "../../../../../API/orders/cutting/detail/DetailService";
import ModalAddDetailOrRequestsCuttingForFiles from "./ModalAddDetailOrRequestsCuttingForFiles";
import FileService from "../../../../../API/orders/orders/organization/FileService";
import ModalCreateOrUpdateDetail from "./ModalCreateOrUpdateDetail";
import DetailUtil from "../../../../../utils/cutting/DetailUtil";
import {clearModelDetailCache} from "../../../../../utils/cutting/modelDetailCache";
import ModalConfirm from "../../../modal/ModalConfirm";
import ButtonSelectAction from "../../../button/ButtonSelectAction";
import {ModalSelectAction} from "../../../modal/ModalSelectAction";
import {Link, useNavigate} from "react-router-dom";
import ButtonCreate from "../../../button/ButtonCreate";
import selectionTableUtil, {normalizeSelection} from "../../../../../utils/common/SelectionTableUtil";
import MenuItem from "@mui/material/MenuItem";
import DetailReserveService from "../../../../../API/organization/DetailReserveService";
import DetailWarehouseService from "../../../../../API/organization/DetailWarehouseService";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModalSeeDetail from "../../customer-detales/SeeDetail";
import ModalAddToWarehouse from "./ModalAddToWarehouse";
import ModalRulesModifying from "../../../modal/ModalRulesModifying";
import {replaceEmptyStringsOnNull} from "../../../../../utils/ReplaceEmptyStringsOnNull";
import ModifyingDetailsOrderService
    from "../../../../../API/orders/optimization/organization/ModifyingDetailsOrderService";
import ExportModal from "../../../modal/ExportModal";
import OptimizationService from "../../../../../API/orders/optimization/organization/OptimizationService";
import {handlerExport} from "../../../../../pages/common/settings/handlerExport";
import VersoDetailService from "../../../../../API/organization/VersoDetailService";
import DetailCompositionController from "../../../../../API/organization/DetailCompositionController";
import AddDetailBasedOnDetail from "../../../modal/AddDetailBasedOnDetail";
import PatternsController from "../../../../../API/organization/PatternsController";

const DetailTable = ({
                         data,
                         setData,
                         isError,
                         unableCut,
                         unableTurn,
                         setUnableCut,
                         setUnableTurn,
                         isColumnMaterial,
                         isColumnOrder,
                         isColumnSequentialNumber,
                         enableGrouping,
                         columnGrouping,
                         expanded,
                         warehouse,
                         requestsCuttingId,
                         optimizationId,
                         change,
                         setChange,
                         isOptimization,
                         materialList,
                         isRedirectPlans,
                         isButtonRunModify,
                         isButtonAddDetail,
                         isAddDetailForFiles,
                         isColumnCut,
                         isColumnTurn,
                         enableEditing,
                         hideQuantity,
                         hideHeight,
                         validateOversizeDetails,
                         onDetailValidationChange,
                         enableRowSelection,
                         rowSelection,
                         setRowSelection,
                         handleModalAlert,
                         tableOptions,
                         tableOptionsHandle,
                         isReserve,
                         isWarehouse,
                         isModal,
                         params,
                         selectedString,
                         setSelectedString,
                         viewingAvailable = true,
                         buttonContainerVisible = true,
                         isDetailModel,
                         errorIds,
                         settings,
                         enableExpanding,
                         composition,
                         isPattern,
                         globalFilter,
                         handleSearchQuery,
                         filteredData,
                         columnsFilter,
                         moduleId,
                         patternId
                     }) => {

        const profile = JSON.parse(localStorage.getItem("profile"))
        const isVerso = !!profile?.userRoles.find(el => el.name === "ROLE_VERSO")
        const MAX_DETAIL_DIMENSION = 2760;
        const isDetailOversize = (row) =>
            (isOptimization || validateOversizeDetails)
            && Number(row?.height) <= 26
            && (Number(row?.length) > MAX_DETAIL_DIMENSION || Number(row?.width) > MAX_DETAIL_DIMENSION);
        const isDetailDuplicatePosition = (row) => Boolean(errorIds?.includes(row?.position));
        const getDetailValidationTooltip = (row) => {
            const parts = [];
            if (isDetailDuplicatePosition(row)) {
                parts.push('Одинаковая позиция, но разные параметры детали (размер, кромки и т.п.).');
            }
            if (isDetailOversize(row)) {
                parts.push(
                    `При толщине до 26 мм сторона W или H не должна превышать ${MAX_DETAIL_DIMENSION} мм `
                    + `(W = ${row?.length ?? '—'}, H = ${row?.width ?? '—'}, толщина = ${row?.height ?? '—'}).`,
                );
            }
            return parts.join(' ');
        };
        const isDetailHighlighted = (row) =>
            isDetailDuplicatePosition(row) || isDetailOversize(row);
        const [createOrUpdateModalOpen, setCreateOrUpdateModalOpen] = useState(false);
        const [errorModalOpen, setErrorModalOpen] = useState(false);
        const [infoModalOpen, setInfoModalOpen] = useState(false);

        const [warehouseModalOpen, setWarehouseModalOpen] = useState(false)
        const [detailInPatternModalOpen, setDetailInPatternModalOpen] = useState(false)

        const [modalAddDetailForFilesOpen, setModalAddDetailForFilesOpen] = useState(false);
        const [isNew, setIsNew] = useState(null);

        const [currentEditRowData, setCurrentEditRowData] = useState(null);
        const [currentEditRowId, setCurrentEditRowId] = useState(null);

        const [modalModifying, setModalModifying] = useState(false)

        const [materialId, setMaterialId] = useState(null);

        const [seeDetailData, setSeeDetailData] = useState({position: null, data: null})
        const popoverOpen = Boolean(seeDetailData.position);
        const seeDetailLeaveTimerRef = useRef(null);

        useEffect(() => () => {
            if (seeDetailLeaveTimerRef.current) {
                clearTimeout(seeDetailLeaveTimerRef.current);
            }
        }, []);

        const [isLoading, setIsLoading] = useState(false);

        const [exportModal, setExportModal] = useState(false)

        const [orderNumberConfirm, setOrderNumberConfirm] = useState(false)
        const [isOrderNumberAdd, setisOrderNumberAdd] = useState(false)
        const [showColumnFilters, setShowColumnFilters] = useState(false)
        const [openModelDetailSelection, setOpenModelDetailSelection] = useState(false)
        const [bulkDeleteModelDetailsConfirmOpen, setBulkDeleteModelDetailsConfirmOpen] = useState(false)

        const settingsModelDetailBulkActions = isDetailModel && settings && enableRowSelection
        const modelDetailSelectionCount = rowSelection?.length ?? 0

        const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection ?? (() => {}))
        const currentSelection = normalizeSelection(rowSelection ?? [])

        const handleBulkDeleteModelDetails = useCallback(() => {
            const ids = rowSelection ?? []
            if (ids.length === 0) {
                setBulkDeleteModelDetailsConfirmOpen(false)
                return
            }
            DetailService.deleteModelDetailsByIds(ids)
                .then(function () {
                    ids.forEach((id) => clearModelDetailCache(id))
                    const removed = new Set(ids.map(String))
                    const newData = data.filter((el) => !removed.has(String(el.id)))
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    setRowSelection?.([])
                    setBulkDeleteModelDetailsConfirmOpen(false)
                    handleModalAlert("Данные удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        }, [
            data,
            globalFilter,
            handleModalAlert,
            handleSearchQuery,
            rowSelection,
            setData,
            setRowSelection,
        ])

        const handleModelDetailSelectAction = (type) => {
            setOpenModelDetailSelection(false)
            if (type === "delete") {
                setBulkDeleteModelDetailsConfirmOpen(true)
            }
        }

        const handleShowColumnFilters = () => {
            setShowColumnFilters(!showColumnFilters)
            if (showColumnFilters) {
                handleSearchQuery([], data, null, true)
            }
        }

        const handleReturn = (row) => {
            ModifyingDetailsOrderService.excluded(row.id, false)
                .then(function () {
                    const newData = data.map(el => el.id === row.id ? {...el, excluded: false} : el)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                    handleModalAlert("Данные изменены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        }
        const setEditOrderNumber = (add) => {
            setOrderNumberConfirm(true)
            setisOrderNumberAdd(add)
        }
        const handleOrderNumberConfirm = () => {
            const api = isOrderNumberAdd ? OptimizationService.addNumberOrder : OptimizationService.deleteNumberOrder
            api(optimizationId)
                .then(function (response) {
                    setData(response.data)
                    handleSearchQuery(globalFilter, response.data)
                    setOrderNumberConfirm(false)
                    handleModalAlert(isOrderNumberAdd ? "Номера заказа добвлены" : "Номера заказа удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        }

        const handleVersoDetail = (cutting) => {
            const api = cutting ? VersoDetailService.downloadCutting : VersoDetailService.downloadDrilling
            handlerExport(() => api(optimizationId), handleModalAlert)
        }

        const handleDeleteRow = useCallback(
            (row) => {
                if (isPattern) {
                    PatternsController.deleteDetail(moduleId, patternId, row.id)
                        .then(function () {
                            const newData = data.filter(el => el.id !== row.id)
                            setData(newData)
                            handleSearchQuery(globalFilter, newData)
                            handleModalAlert("Данные удалены", 'success')
                        })
                        .catch(function (error) {
                            handleModalAlert(error);
                        })
                } else if (isDetailModel) {
                    DetailService.deleteModelDetails(row.id)
                        .then(function () {
                            clearModelDetailCache(row.id)
                            const newData = data.filter(el => el.id !== row.id)
                            setData(newData)
                            handleSearchQuery(globalFilter, newData)
                            handleModalAlert("Данные удалены", 'success')
                        })
                        .catch(function (error) {
                            handleModalAlert(error);
                        })
                } else if (isOptimization) {
                    DetailService.deleteFromOptimization(row.id, optimizationId)
                        .then(function () {
                            const newData = data.filter(el => el.id !== row.id)
                            setData(newData)
                            handleSearchQuery(globalFilter, newData)
                            handleModalAlert("Данные удалены", 'success')
                        })
                        .catch(function (error) {
                            handleModalAlert(error);
                        })
                } else if (isReserve) {
                    DetailReserveService.delete(row.id)
                        .then(function () {
                            const newData = data.filter(el => el.id !== row.id)
                            setData(newData)
                            handleSearchQuery(globalFilter, newData)
                            handleModalAlert("Данные удалены", 'success')
                        })
                        .catch(function (error) {
                            handleModalAlert(error);
                        })
                } else if (isWarehouse) {
                    DetailWarehouseService.delete(row.id)
                        .then(function () {
                            const newData = data.filter(el => el.id !== row.id)
                            setData(newData)
                            handleSearchQuery(globalFilter, newData)
                            handleModalAlert("Данные удалены", 'success')
                        })
                        .catch(function (error) {
                            handleModalAlert(error);
                        })
                } else {
                    DetailService.delete(row.id, warehouse)
                        .then(function () {
                            const newData = data.filter(el => el.id !== row.id)
                            setData(newData)
                            handleSearchQuery(globalFilter, newData)
                            handleModalAlert("Данные удалены", 'success')
                        })
                        .catch(function (error) {
                            handleModalAlert(error);
                        })
                }
            },
            [data],
        );

        const handleUnableCheckboxCut = (id, status) => {
            if (isReserve) {
                DetailReserveService.unableCut(id, status).then(function () {
                    handleUnableCut(id, status)
                    handleModalAlert("Данные изменены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    });
            } else {
                DetailService.unableCutOrTurn(id, status, 'cut', warehouse).then(function () {
                    handleUnableCut(id, status)
                    handleModalAlert("Данные изменены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    });
            }

        };

        const handleUnableCut = (id, status) => {
            unableCut[id] = status
            setUnableCut(prevState => ({
                ...prevState,
                [id]: status
            }));
        };

        const handleUnableCheckboxTurn = (id, status) => {
            if (isReserve) {
                DetailReserveService.unableTurn(id, status).then(function () {
                    handleUnableCut(id, status)
                    handleModalAlert("Данные изменены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    });
            } else {
                DetailService.unableCutOrTurn(id, status, 'turn', warehouse).then(function () {
                    handleUnableTurn(id, status);
                    handleModalAlert("Данные изменены", 'success')
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    });
            }
        };

        const handleUnableTurn = (id, status) => {
            unableTurn[id] = status
            setUnableTurn(prevState => ({
                ...prevState,
                [id]: status
            }));
        };

        const handleAddDetail = () => {
            if (isPattern) {
                setDetailInPatternModalOpen(true)
            } else if (isWarehouse) {
                setWarehouseModalOpen(true)
            } else {
                setIsNew(true);
                const detail = composition ? {
                    "position": "",
                    "name": "",
                    "length": "",
                    "width": "",
                    "height": 18,
                    "l1": "",
                    "l2": "",
                    "w1": "",
                    "w2": "",
                    "groove": "",
                    "modelSeries": "",
                    "nameMaterial": "",
                    "groupModel": "",
                    "l1Name": "",
                    "l2Name": "",
                    "w1Name": "",
                    "w2Name": ""
                } : isDetailModel ? {
                    "position": "",
                    "name": "",
                    "length": "",
                    "width": "",
                    "l1": "",
                    "l2": "",
                    "w1": "",
                    "w2": "",
                    "groove": "",
                    "modelSeries": "",
                    "nameMaterial": "",
                    "groupModel": "",
                    "l1Name": "",
                    "l2Name": "",
                    "w1Name": "",
                    "w2Name": ""
                } : isReserve ? {
                    position: "",
                    name: "",
                    length: "",
                    width: "",
                    reserveLimit: 0
                } : {
                    position: "",
                    name: "",
                    length: "",
                    width: "",
                    quantity: 0,
                    turn: false,
                    cut: true,
                    l1: "",
                    l2: "",
                    w1: "",
                    w2: "",
                    groove: ""
                };

                setCurrentEditRowData(detail);
                setCreateOrUpdateModalOpen(true);
            }
        };

        const handleUpdateModel = (row) => {
            if (isWarehouse) {
                setWarehouseModalOpen(true)

            } else {
                setCreateOrUpdateModalOpen(true);
                setIsNew(false);
                setCurrentEditRowId(row.id);
            }
            setCurrentEditRowData(row);
        }


        const handleSubmitUpdateDetail = (values, close) => {
            const row2 = data.find(el => el.id === currentEditRowId)

            if (!DetailUtil.compareEqual(values, row2)) {
                const mergedRow = replaceEmptyStringsOnNull(
                    isOptimization ? {...values, modified: true, id: currentEditRowId} : {...row2, ...values},
                );
                const listForDuplicateCheck = data.map((el) =>
                    detailOrderIdsEqual(el.id, currentEditRowId) ? mergedRow : el,
                );
                const error = DetailUtil.checkDuplicatePositions(listForDuplicateCheck, isOptimization);

                if (error.length === 0) {
                    setIsLoading(true)
                    if (isDetailModel) {
                        DetailService.updateModelDetails(replaceEmptyStringsOnNull({
                            "name": values.name,
                            "position": values.position,
                            "length": values.length,
                            "width": values.width,
                            "l1": values.l1,
                            "l1Name": values.l1Name,
                            "l2": values.l2,
                            "l2Name": values.l2Name,
                            "w1": values.w1,
                            "w1Name": values.w1Name,
                            "w2": values.w2,
                            "w2Name": values.w2Name,
                            "groove": values.groove,
                            "nameMaterial": values.nameMaterial,
                            "groupModel": values.groupModel,
                            "modelSeries": values.modelSeries,
                        }), values.id).then(function (response) {
                            clearModelDetailCache(values.id)
                            const newData = data.map(el => el.id === currentEditRowId ? response.data : el)
                            setData(newData)
                            handleSearchQuery(globalFilter, newData)
                            handleCloseCreateOrUpdate();
                            close()
                            handleModalAlert("Данные изменены", 'success')
                        })
                            .catch(function (error) {
                                handleModalAlert(error);
                            })
                            .finally(() => setIsLoading(false))
                    } else if (isOptimization) {
                        DetailService.updateOptimization(replaceEmptyStringsOnNull(values), optimizationId,
                        ).then(function (response) {
                            const newData = data.map(el => el.id === currentEditRowId ? {...el, excluded: true} : el)
                            setData(newData)
                            handleSearchQuery(globalFilter, newData)
                            handleCloseCreateOrUpdate();
                            close()
                            handleModalAlert("Данные изменены", 'success')
                        })
                            .catch(function (error) {
                                handleModalAlert(error);
                            })
                            .finally(() => setIsLoading(false))
                    } else if (isReserve) {
                        DetailReserveService.edit(values.id, replaceEmptyStringsOnNull({
                                "name": values.name,
                                "position": values.position,
                                "length": values.length,
                                "width": values.width,
                                "l1": values.l1,
                                "l1Name": values.l1Name,
                                "l2": values.l2,
                                "l2Name": values.l2Name,
                                "w1": values.w1,
                                "w1Name": values.w1Name,
                                "w2": values.w2,
                                "w2Name": values.w2Name,
                                "groove": values.groove,
                                "reserveLimit": values.reserveLimit,
                                "materialOptionOrganizationId": values.materialOptionOrganizationId,
                            }),
                        ).then(function (response) {
                            const newData = data.map(el => el.id === currentEditRowId ? response.data : el)
                            setData(newData)
                            handleSearchQuery(globalFilter, newData)
                            handleCloseCreateOrUpdate();
                            close()
                            handleModalAlert("Данные изменены", 'success')
                        })
                            .catch(function (error) {
                                handleModalAlert(error);
                            })
                            .finally(() => setIsLoading(false))
                    } else {
                        const mergedFormRow = replaceEmptyStringsOnNull({
                            ...row2,
                            ...values,
                        });
                        DetailService.update(mergedFormRow, warehouse,
                        ).then(function (response) {
                            setData((prev) => {
                                const next = prev.map((el) =>
                                    detailOrderIdsEqual(el.id, currentEditRowId)
                                        ? applyDetailOrderUpdateToRow(el, response?.data, mergedFormRow)
                                        : el,
                                );
                                handleSearchQuery(globalFilter, next);
                                return next;
                            });
                            handleCloseCreateOrUpdate();
                            close();
                            handleModalAlert("Данные изменены", 'success');
                        })
                            .catch(function (error) {
                                handleModalAlert(error);
                            })
                            .finally(() => setIsLoading(false))
                    }
                } else {
                    onDetailValidationChange?.(error);
                    handleModalAlert("Одинаковые позиции, но разные детали");
                    setErrorModalOpen(true)
                }
            } else {
                handleModalAlert("Детали одинаковые");
                setErrorModalOpen(true)
            }
        }
        const handleEditToWarehouse = (close, formState) => {
            DetailWarehouseService.edit(currentEditRowData.id, formState.count).then(function (response) {
                setCurrentEditRowData(null);
                close()
                if (response.data.quantity === 0) {
                    const newData = data.filter(el => el.id !== currentEditRowData.id)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                } else {
                    const newData = data.map(el => el.id === currentEditRowData.id ? response.data : el)
                    setData(newData)
                    handleSearchQuery(globalFilter, newData)
                }
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }
        const handleAddToWarehouse = (close, formState, selectedString) => {
            DetailWarehouseService.save([{...formState, reserveId: selectedString.id}]).then(function (response) {
                setChange(!change)
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length}))
                setCurrentEditRowData(null);
                close()
                handleModalAlert("Данные изменены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        const handleSubmitCreateDetail = (values, close) => {
            const listForDuplicateCheck = [...data, replaceEmptyStringsOnNull(values)];
            const error = DetailUtil.checkDuplicatePositions(listForDuplicateCheck, isOptimization);
            if (error.length === 0) {
                setIsLoading(true)
                if (isDetailModel) {
                    const api = composition ? DetailCompositionController.save : DetailService.addModelDetails
                    const {cut, turn, quantity, ...rest} = values
                    api(replaceEmptyStringsOnNull(rest)).then(function (response) {
                        const newData = [...data, response.data]
                        setData(newData)
                        handleSearchQuery(globalFilter, newData)
                        handleCloseCreateOrUpdate();
                        close()
                        handleModalAlert("Данные добавлены", 'success')
                    })
                        .catch(function (error) {
                            handleModalAlert(error);
                        })
                        .finally(() => setIsLoading(false))
                } else if (isOptimization) {
                    const currentMaterialId = materialId === null ? materialList[0].id : materialId;
                    DetailService.saveOptimizations(replaceEmptyStringsOnNull(values), optimizationId, currentMaterialId).then(function (response) {
                        const newData = [...data, response.data]
                        setData(newData)
                        handleSearchQuery(globalFilter, newData)
                        handleCloseCreateOrUpdate();
                        setChange(!change)
                        close()
                        handleModalAlert("Данные добавлены", 'success')
                    })
                        .catch(function (error) {
                            handleModalAlert(error);
                        })
                        .finally(() => setIsLoading(false))
                } else if (isReserve) {
                    DetailReserveService.save(replaceEmptyStringsOnNull(values)).then(function (response) {
                        const newData = [...data, response.data]
                        setData(newData)
                        handleSearchQuery(globalFilter, newData)
                        handleCloseCreateOrUpdate();
                        close()
                        handleModalAlert("Данные добавлены", 'success')
                    })
                        .catch(function (error) {
                            handleModalAlert(error);
                        })
                        .finally(() => setIsLoading(false))
                } else {
                    DetailService.save(replaceEmptyStringsOnNull(values), requestsCuttingId, warehouse).then(function (response) {
                        const newData = [...data, response.data]
                        setData(newData)
                        handleSearchQuery(globalFilter, newData)
                        handleCloseCreateOrUpdate();
                        setChange(!change)
                        close()
                        handleModalAlert("Данные добавлены", 'success')
                    })
                        .catch(function (error) {
                            handleModalAlert(error);
                        })
                        .finally(() => setIsLoading(false))
                }

            } else {
                onDetailValidationChange?.(error);
                handleModalAlert("Одинаковые позиции, но разные детали");
                setErrorModalOpen(true)
            }
        }


        const handleCloseCreateOrUpdate = () => {
            setCurrentEditRowData(null);
            setCurrentEditRowId(null);
            setIsNew(null);
            setCreateOrUpdateModalOpen(false);
            setMaterialId(null)
        };

        const handleCloseWarehouseModal = () => {
            setWarehouseModalOpen(false)
            setCurrentEditRowData(null);
        }

        const handleSubmitModify = (ids) => {
            setIsLoading(true)
            DetailService.modifyOptimizations(optimizationId, ids).then(function () {
                setInfoModalOpen(true);
                handleModalAlert("Модификция прошла успешна", 'success');
                setChange(!change)
                setModalModifying(false);
            })
                .catch(function (error) {
                    handleModalAlert(error);
                }).finally(() => setIsLoading(false))
        }

        const handleDeleteModify = () => {
            setIsLoading(true)
            DetailService.deleteModify(optimizationId).then(function () {
                const newData = data
                    .filter(el => el.modified?.toString() !== 'true')
                    .map(el => el.excluded?.toString() === 'true' ? {...el, excluded: false} : el)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                handleModalAlert("Модификация удалена", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                }).finally(() => setIsLoading(false))
        }

        const handleAddDetailOnPattern = (detail, close) => {
            setIsLoading(true)
            PatternsController.addDetail(moduleId, patternId, detail.id).then(function (response) {
                const newData = [...data, response.data]
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                handleModalAlert("Деталь добавлена", 'success');
                close()
            })
                .catch(function (error) {
                    handleModalAlert(error);
                }).finally(() => setIsLoading(false))
        }

        const handleSubmitExport = (selcoFileFieldsOrderId) => {
            handlerExport(() => OptimizationService.downloadFileSelco(optimizationId, selcoFileFieldsOrderId), handleModalAlert)
        }

        const navigate = useNavigate();

        const handleOpenSeeDetail = (position, rowData) => {
            if (seeDetailLeaveTimerRef.current) {
                clearTimeout(seeDetailLeaveTimerRef.current);
                seeDetailLeaveTimerRef.current = null;
            }
            setSeeDetailData({position, id: rowData.id, data: rowData})
        }

        const handleCloseSeeDetail = () => {
            seeDetailLeaveTimerRef.current = setTimeout(() => {
                setSeeDetailData({position: null, data: null});
                seeDetailLeaveTimerRef.current = null;
            }, 300);
        }

        const loadModelDetail = isDetailModel && !composition;


        const columns = useMemo(() => {
            const baseColumns = [
                {
                    id: 'position',
                    header: 'Позиция',
                    accessorKey: "position",
                    size: 300,
                    grow: true,
                    Cell: ({cell, row}) => {
                        return <li key={cell.getValue()} style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingRight: "10px"
                        }}>
                            <Tooltip
                                arrow
                                placement="right"
                                disableHoverListener={row.original.requiresImprovement !== true}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            width: '220px',
                                        },
                                    },
                                }}
                                title="При импорте из файла приложение не смогло определить тип кромки">
                                {isModal ? cell.getValue() :
                                    <Link
                                        to={isWarehouse ? `/organization/requests-cutting/warehouse/${row.original.id}` : isReserve ? `/organization/requests-cutting/reserve/${row.original.id}` : (composition || isPattern) ? `/organization/requests-cutting/composition/${row.original.id}` : isDetailModel ? `/organization/requests-cutting/detail-model/${row.original.id}` : `/organization/requests-cutting/details/${params?.id}/${encodeURIComponent(params?.numberRequestsCutting)}/detail/${row.original.id}`}
                                    >
                                        <Box sx={{
                                            color: (theme) => isDetailHighlighted(cell.row.original) ? "white" : row.original.requiresImprovement ? theme.palette.error.main : "#006CCC"
                                        }}>
                                            {cell.getValue() === null ? '' : cell.getValue()}
                                        </Box>
                                    </Link>}
                            </Tooltip>
                            {viewingAvailable && <Box
                                component="span"
                                onMouseEnter={(event) => handleOpenSeeDetail(event.currentTarget, row.original)}
                                onMouseLeave={handleCloseSeeDetail}
                                sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "4px",
                                    flexShrink: 0,
                                }}>
                                <VisibilityIcon
                                    aria-owns={popoverOpen ? 'mouse-over-popover' : undefined}
                                    aria-haspopup="true"
                                    sx={{
                                        color: (theme) => theme.palette.text.light,
                                        fontSize: "24px",
                                        cursor: "pointer",
                                        pointerEvents: 'none',
                                    }}
                                />
                            </Box>}

                        </li>
                    }
                },
                {
                    id: 'name',
                    header: 'Наименование',
                    accessorKey: 'name',
                    minSize: 60,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>
                },
                {
                    id: 'length',
                    header: 'W',
                    accessorKey: 'length',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>
                },
                {
                    id: 'width',
                    header: 'H',
                    accessorKey: 'width',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>
                },
                {
                    id: 'l1',
                    header: 'l1',
                    accessorKey: 'l1',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => {
                        return <Tooltip arrow placement="top" title={row.original.l1Name}>
                            <Box sx={{
                                color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                            }}>{cell.getValue()}</Box>
                        </Tooltip>
                    },
                },
                {
                    id: 'l2',
                    header: 'l2',
                    accessorKey: 'l2',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => {
                        return <Tooltip arrow placement="top" title={row.original.l2Name}>
                            <Box sx={{
                                color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                            }}>{cell.getValue()}</Box>
                        </Tooltip>
                    },
                },
                {
                    id: 'w1',
                    header: 'w1',
                    accessorKey: 'w1',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => {
                        return <Tooltip arrow placement="top" title={row.original.w1Name}>
                            <Box sx={{
                                color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                            }}>{cell.getValue()}</Box>
                        </Tooltip>
                    },
                },
                {
                    id: 'w2',
                    header: 'w2',
                    accessorKey: 'w2',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => {
                        return <Tooltip arrow placement="top" title={row.original.w2Name}>
                            <Box sx={{
                                color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                            }}>{cell.getValue()}</Box>
                        </Tooltip>
                    },
                },
                {
                    id: 'groove',
                    header: 'Паз',
                    accessorKey: 'groove',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>
                },
                {
                    header: 'id',
                    id: 'id',
                    accessorKey: 'id',
                    enableHiding: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableEditing: false,
                },
            ];

            if ((!hideQuantity || isColumnSequentialNumber) && !isDetailModel) {
                baseColumns.splice(1, 0, {
                    id: 'quantity',
                    header: 'кол.',
                    accessorKey: 'quantity',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>,
                });
            }
            if (!hideHeight) {
                const widthIndex = baseColumns.findIndex((column) => column.id === 'width');
                baseColumns.splice(widthIndex + 1, 0, {
                    id: 'height',
                    header: 'Тол.',
                    accessorKey: 'height',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>,
                });
            }
            if (isReserve || isWarehouse) {
                baseColumns.splice(1, 0, {
                    id: 'reserveLimit',
                    header: 'Лимит резервов',
                    accessorKey: 'reserveLimit',
                    minSize: 15,
                    maxSize: 15,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : (row.original.ignored ? theme.palette.pencil.main : 'black'))
                    }}>{cell.getValue()}</Box>,
                });
            }
            if (isColumnCut && !isModal) {
                baseColumns.splice(1, 0, {
                    id: 'cut',
                    header: 'Кроить',
                    accessorKey: 'cut',
                    size: 8,
                    enableEditing: false,
                    filterVariant: 'multi-select',
                    filterSelectOptions: FilterUtil.statusList,
                    filterFn: (row, id, filterValue) => {
                        return FilterUtil.checkStatus(row.getValue(id), filterValue)
                    },
                    Cell: ({cell, row}) => <CellCheckboxWithUnable
                        id={row.id}
                        unable={unableCut}
                        setUnable={handleUnableCheckboxCut}
                        disabled={row.original.excluded || (isReserve && row.original.quantity !== 0 || isWarehouse)}
                    >
                    </CellCheckboxWithUnable>,
                });
            }

            if (isColumnTurn && !isModal) {
                baseColumns.splice(2, 0, {
                    id: 'turn',
                    header: 'Поворот',
                    accessorKey: 'turn',
                    size: 8,
                    enableEditing: false,
                    filterVariant: 'multi-select',
                    filterSelectOptions: FilterUtil.statusList,
                    filterFn: (row, id, filterValue) => {
                        return FilterUtil.checkStatus(row.getValue(id), filterValue)
                    },
                    Cell: ({cell, row}) => <CellCheckboxWithUnable
                        id={row.id}
                        unable={unableTurn}
                        setUnable={handleUnableCheckboxTurn}
                        disabled={row.original.excluded || (isReserve && row.original.quantity !== 0 || isWarehouse)}
                    >
                    </CellCheckboxWithUnable>,
                });
            }
            if (isDetailModel) {
                baseColumns.splice(14, 0, {
                    id: 'nameMaterial',
                    header: 'материал',
                    accessorFn: (row) => row.nameMaterial ?? row.materialName ?? '',
                    minSize: 100,
                });
                baseColumns.splice(14, 0, {
                    id: 'modelSeries',
                    header: 'Серия',
                    accessorKey: 'modelSeries',
                    minSize: 100,
                });
                baseColumns.splice(14, 0, {
                    id: 'groupModel',
                    header: 'Описание модели',
                    accessorKey: 'groupModel',
                    minSize: 100,
                });
            }
            if (isColumnMaterial) {
                baseColumns.splice(14, 0, {
                    id: 'materialOptionOrganizationName',
                    header: 'материал',
                    accessorKey: 'materialOptionOrganizationName',
                    minSize: 400,
                });
            }

            if (isColumnOrder) {
                baseColumns.splice(isColumnMaterial ? 15 : 14, 0, {
                    id: 'orderNumber',
                    header: 'Заказ',
                    accessorKey: 'orderNumber',
                    minSize: 25,
                    maxSize: 30,
                    Cell: ({cell, row}) => <Box sx={{
                        color: (theme) => row.original.modified ? theme.palette.success.main : (row.original.excluded ? theme.palette.error.main : 'black')
                    }}>{cell.getValue()}</Box>,
                });
            }
            if (isColumnSequentialNumber) {
                baseColumns.splice(0, 0, {
                    id: 'sequentialNumber',
                    header: 'Порядковый номер',
                    accessorKey: 'sequentialNumber',
                    minSize: 25,
                    maxSize: 30,
                });
            }


            return baseColumns;

        }, [data, setData, isColumnMaterial, isColumnOrder, filteredData, hideQuantity, hideHeight, isColumnSequentialNumber, isDetailModel, isReserve, isWarehouse, isColumnCut, isColumnTurn, isModal, isPattern, viewingAvailable, params]);

        const runModify = () => {
            setModalModifying(true);
        };

        const menuItem = composition || isPattern ? [
            {type: "delete", text: "Удалить", handler: handleDeleteRow},
        ] : isOptimization ? [
            {type: "edit", text: "Редактировать", handler: handleUpdateModel},
            {type: "delete", text: "Удалить", handler: handleDeleteRow},
            {type: "return", text: "Вернуть", handler: handleReturn},
        ] : [
            {type: "edit", text: "Редактировать", handler: handleUpdateModel},
            {type: "delete", text: "Удалить", handler: handleDeleteRow},
        ]

        const settingsTableMaxHeight = modelDetailSelectionCount > 0
            ? `calc(100vh - 628px)`
            : `calc(100vh - 540px)`

        return (
            <Box sx={{
                display: 'flex', flexDirection: "column", gap: "30px",
                overflow: settingsModelDetailBulkActions ? 'visible' : 'auto',
                maxWidth: isPattern ? "1000px" : settings ? 'calc(100vw - 450px)' : "100vw"
            }}>
                {!isModal && buttonContainerVisible && <Box
                    sx={{display: 'flex', justifyContent: "flex-end",}}
                >
                    <Box sx={{display: 'flex', justifyContent: "spase-between", gap: "9px", flexWrap: 'wrap'}}>
                        {isRedirectPlans &&
                            <ButtonCreate
                                text={"Планы"}
                                width={70}
                                icon={false}
                                onClick={() => navigate('/organization/plans')}
                            />}
                        {isOptimization &&
                            <><ButtonCreate
                                text={"Экспорт"}
                                width={80}
                                icon={false}
                                onClick={() => setExportModal(true)}
                            />
                                <ButtonCreate
                                    text={"Добавить № заказа"}
                                    width={202}
                                    onClick={() => setEditOrderNumber(true)}
                                />
                                <ButtonCreate
                                    text={"Удалить № заказа"}
                                    width={198}
                                    onClick={() => setEditOrderNumber(false)}
                                />
                            </>
                        }
                        {isError && <Tooltip
                            arrow
                            placement="top"
                            title="В таблице есть одинаковые позиции с разными параметрами детали."
                        >
                            <Button
                            size="small"
                            color="secondary"
                            variant="contained"
                            sx={{
                                animation: 'blinking 1s infinite',
                                WebkitAnimation: 'blinking 1s infinite',
                                '@keyframes blinking': {
                                    '0%': {backgroundColor: '#fff'},
                                    '50%': {backgroundColor: '#f00'},
                                    '100%': {backgroundColor: '#fff'},
                                },
                            }}
                        >
                            Ошибка позиции
                        </Button>
                        </Tooltip>}
                        {(isButtonAddDetail || isPattern) &&
                            <ButtonCreate
                                text={"Добавить деталь"}
                                width={190}
                                onClick={handleAddDetail}
                            />}
                        {!isOptimization && isAddDetailForFiles &&
                            <ButtonCreate
                                text={"Добавить детали из файла"}
                                width={250}
                                icon={false}
                                onClick={() => setModalAddDetailForFilesOpen(true)}
                            />}
                        {isButtonRunModify &&
                            <ButtonCreate
                                text={"Модифицировать"}
                                width={190}
                                onClick={() => runModify()}
                            />}
                        {isOptimization && isButtonRunModify &&
                            <ButtonCreate
                                text={"Удалить модификацию"}
                                width={220}
                                icon={false}
                                disabled={isLoading}
                                onClick={handleDeleteModify}
                            />}
                        {(isOptimization && isVerso) && <>
                            <ButtonCreate
                                text={"Раскрой"}
                                width={80}
                                icon={false}
                                onClick={() => handleVersoDetail(true)}
                            />
                            <ButtonCreate
                                text={"Сверление"}
                                width={100}
                                icon={false}
                                onClick={() => handleVersoDetail(false)}
                            />
                        </>}
                    </Box>
                </Box>}
                <MaterialReactTable
                    muiTableBodyCellProps={({cell, table}) => {
                        return ({
                            sx: () => ({
                                p: cell.column.id === "cut" || cell.column.id === "turn" ? 0 : '0px 0px 0px 10px',
                                m: '0px 0px 0px 0px',
                                border: "none",
                                backgroundColor: isDetailHighlighted(cell.row.original) && "red",
                                "&:after": {
                                    display: "none",
                                },
                                "& td:after": {
                                    "&:hover": {
                                        backgroundColor: "red"
                                    }
                                },
                                "&:not(:last-of-type)": {
                                    borderRight: '1px solid #EAEBEA',
                                },
                                "&:first-of-type": (enableEditing && !isModal) && !expanded && {
                                    padding: 0,
                                    width: "50px",
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: (theme) => theme.palette.text.light,
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },
                                "& li": {
                                    listStyleType: "none",
                                    "& a": {
                                        color: "#006CCC",
                                        textDecoration: "none",
                                        "&:hover": {
                                            textDecoration: "underline"
                                        }
                                    }
                                }
                            })
                        })
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem"
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        const validationTooltip = getDetailValidationTooltip(row.original);
                        const rowProps = {
                            onClick: () => isModal && setSelectedString(row.original),
                            sx: () => ({
                                height: '36px',
                                cursor: isModal && "pointer",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                '&:nth-of-type(even)': {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : (theme) => theme.palette.primary.lightGrey,
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                    },
                                },
                                backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light : "white",
                                "&:hover": {
                                    backgroundColor: row.original.id === selectedString?.id ? (theme) => theme.palette.primary.light50 : (theme) => theme.palette.primary.stroke,
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                            }),
                        };
                        if (!validationTooltip) {
                            return rowProps;
                        }
                        return {
                            ...rowProps,
                            component: (props) => (
                                <Tooltip title={validationTooltip} arrow placement="top">
                                    <TableRow {...props} />
                                </Tooltip>
                            ),
                        };
                    }}
                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                        'mrt-row-select': {
                            size: "50px",
                            grow: false,
                        },
                        "mrt-row-expand": {
                            size: "50px",
                            grow: false,

                        }
                    }}
                    columns={columns}
                    data={filteredData}
                    rowHeight={13}
                    columnSpacing={1}
                    initialState={{
                        columnVisibility: {
                            id: false,
                            material: isColumnMaterial,
                            order: isColumnOrder,
                            l1: !isPattern && !isModal,
                            l2: !isPattern && !isModal,
                            w1: !isPattern && !isModal,
                            w2: !isPattern && !isModal,
                            quantity: !isPattern && !isModal && !hideQuantity,
                            groove: !isPattern && !isModal,
                        },
                        density: "compact",
                        grouping: columnGrouping,
                        expanded: expanded,
                        sorting: [{id: 'position', desc: false}],
                    }}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    onGlobalFilterChange={(value) => {
                        handleSearchQuery(value, data, null)
                    }}
                    onColumnFiltersChange={(updater) => {
                        handleSearchQuery(updater(columnsFilter), data, null, true)
                    }}
                    onShowColumnFiltersChange={handleShowColumnFilters}
                    paginateExpandedRows={false}
                    enableExpanding={enableExpanding}
                    enableToolbarInternalActions={false}
                    enableGrouping={enableGrouping}
                    enableRowSelection={enableRowSelection ?? (Boolean(isDetailModel && settings))}
                    onRowSelectionChange={onRowSelectionChange}
                    state={{
                        showColumnFilters: showColumnFilters,
                        columnFilters: columnsFilter,
                        globalFilter: globalFilter,
                        rowSelection: currentSelection,
                        showGlobalFilter: true,
                        pagination: tableOptions,
                    }}
                    getRowId={(originalRow) => originalRow.id}
                    selectionPadding={1}
                    enableRowActions={enableEditing && !isModal}
                    selectionCss={{
                        backgroundColor: 'lightblue',
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: 'blue',
                        borderRadius: '4px',
                    }}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        const disabled = (el.type === "delete" && row.original.dateOfConstructorDocumentation) || (isReserve && row.original.quantity !== 0) || (isOptimization && el.type === "delete" && row.original.excluded) || (isOptimization && el.type === "return" && !row.original.excluded)
                        return <MenuItem
                            key={el.type}
                            disabled={disabled}
                            onClick={() => {
                                el.handler(row.original)
                                closeMenu();
                            }}
                            sx={{
                                margin: "0 8px",
                                borderRadius: "4px",
                                "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                            }}
                        >
                            {el.text}
                        </MenuItem>
                    })}
                    localization={MRT_Localization_RU}
                    selectAllMode={"all"}
                    muiTableContainerProps={{
                        sx: {
                            maxHeight: settings
                                ? settingsTableMaxHeight
                                : isReserve
                                    ? `calc(100vh - 450px)`
                                    : isOptimization && rowSelection.length > 0
                                        ? `calc(100vh - 580px)`
                                        : isOptimization
                                            ? `calc(100vh - 450px)`
                                            : `calc(100vh - 500px)`,
                        }
                    }}
                    muiToolbarAlertBannerProps={{
                        sx: {
                            backgroundColor: (theme) => theme.palette.primary.light,
                            "& .MuiStack-root": {
                                padding: 0,
                            },
                        }
                    }}
                    renderTopToolbar={({table}) => {
                        const selectedCount = table.getSelectedRowModel().rows.length
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "7px",
                            backgroundColor: (theme) => selectedCount > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <Box sx={{display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap"}}>
                                <MRT_ToolbarAlertBanner table={table}/>
                            </Box>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    renderBottomToolbar={({table}) => {
                        const tableProps = table.getState().grouping.length > 0
                            ? {
                                ...table,
                                options: {
                                    ...table.options,
                                    localization: {
                                        ...table.options.localization,
                                        rowsPerPage: `Всего строк: ${tableOptions.totalElements}. Сгруппированных элементов на странице:`
                                    }
                                }
                            }
                            : table
                        return <MRT_BottomToolbar table={tableProps}/>
                    }}
                />
                {modalAddDetailForFilesOpen && <ModalAddDetailOrRequestsCuttingForFiles
                    title={'Добавить детали из файла'}
                    labelForm={'Загрузить файлы деталей'}
                    modalOpen={modalAddDetailForFilesOpen}
                    handleClose={() => setModalAddDetailForFilesOpen(false)}
                    requestsCuttingId={requestsCuttingId}
                    requestsCutting={true}
                    change={change}
                    setChange={setChange}
                    upload={FileService.uploadDetailFiles}
                />}
                {createOrUpdateModalOpen && <ModalCreateOrUpdateDetail
                    open={createOrUpdateModalOpen}
                    onClose={handleCloseCreateOrUpdate}
                    title={isNew ? 'Создать деталь' : 'Редактировать деталь'}
                    initValues={currentEditRowData}
                    labelButtonSSubmit={isNew ? 'Создать' : 'Обновить'}
                    handleSubmit={isNew ? handleSubmitCreateDetail : handleSubmitUpdateDetail}
                    isOptimization={isOptimization}
                    isReserve={isReserve}
                    materialList={materialList}
                    setMaterialId={setMaterialId}
                    handleModalAlert={handleModalAlert}
                    isDetailModel={isDetailModel}
                    composition={composition}
                    loading={isLoading}
                />}
                {!isModal && <ModalAddToWarehouse
                    open={warehouseModalOpen}
                    initValue={currentEditRowData}
                    onClose={handleCloseWarehouseModal}
                    handleSubmit={currentEditRowData?.id ? handleEditToWarehouse : handleAddToWarehouse}
                    handleModalAlert={handleModalAlert}
                />}
                {modalModifying && <ModalRulesModifying
                    modalOpen={modalModifying}
                    handleClose={() => setModalModifying(false)}
                    handleSubmit={handleSubmitModify}
                    handleModalAlert={handleModalAlert}
                    isLoading={isLoading}
                />}
                {exportModal && <ExportModal
                    modalOpen={exportModal}
                    handleClose={() => setExportModal(false)}
                    handleSubmit={handleSubmitExport}
                    handleModalAlert={handleModalAlert}
                />}
                {detailInPatternModalOpen && <AddDetailBasedOnDetail
                    modalOpen={detailInPatternModalOpen}
                    handleClose={() => setDetailInPatternModalOpen(false)}
                    handleSubmit={handleAddDetailOnPattern}
                    handleModalAlert={handleModalAlert}
                    loading={isLoading}
                    api={() => DetailCompositionController.get()}
                />}

                {seeDetailData.data && <ModalSeeDetail
                    open={popoverOpen}
                    seeDetailData={seeDetailData}
                    loadModelDetail={loadModelDetail}
                    handleClose={handleCloseSeeDetail}/>}
                <ModalConfirm
                    title={isOrderNumberAdd ? "Подтвердить добавление?" : "Подтвердить удаление?"}
                    modalOpen={orderNumberConfirm}
                    handleClose={() => setOrderNumberConfirm(false)}
                    handleSubmit={handleOrderNumberConfirm}
                    action={"Добавить"}
                />
                {settingsModelDetailBulkActions && modelDetailSelectionCount > 0 && (
                    <Box sx={{
                        position: "fixed",
                        bottom: 24,
                        left: 0,
                        right: 0,
                        zIndex: 1300,
                        display: "flex",
                        justifyContent: "center",
                        pointerEvents: "none",
                        "& .MuiButton-root": {pointerEvents: "auto"},
                    }}>
                        <ButtonSelectAction
                            text={"Выбрать действие"}
                            onClick={() => setOpenModelDetailSelection(true)}
                        />
                    </Box>
                )}
                {settingsModelDetailBulkActions && (
                    <>
                        <ModalSelectAction
                            open={openModelDetailSelection}
                            reset={() => setOpenModelDetailSelection(false)}
                            submit={handleModelDetailSelectAction}
                            modalActions={[{type: "delete", name: "Удалить"}]}
                        />
                        <ModalConfirm
                            title="Удалить выбранные детали?"
                            modalOpen={bulkDeleteModelDetailsConfirmOpen}
                            handleClose={() => setBulkDeleteModelDetailsConfirmOpen(false)}
                            handleSubmit={handleBulkDeleteModelDetails}
                            action={"Удалить"}
                        />
                    </>
                )}
            </Box>
        );
    }
;

export default DetailTable;